import React from 'react';
const MessageFragment = ({ children }) => React.createElement(React.Fragment, null, children);
export const renderMessage = ({ message, args, }) => {
    var _a;
    const rgx = /\{(.*?)\}/gim;
    let result = rgx.exec(message);
    let currentPos = 0;
    const elements = [];
    while (result !== null) {
        const [, argName] = result;
        const ArgValue = (_a = args[argName]) !== null && _a !== void 0 ? _a : `{${argName}}`;
        const substring = message.substring(currentPos, result.index);
        const key = `${argName}-${result.index}`;
        if (substring.length)
            elements.push(React.createElement(MessageFragment, { key: `pre-${key}` }, substring));
        elements.push(typeof ArgValue === 'function' ? (React.createElement(ArgValue, { key: key })) : (React.createElement(MessageFragment, { key: key }, ArgValue)));
        currentPos = rgx.lastIndex;
        result = rgx.exec(message);
    }
    const substring = message.substring(currentPos);
    if (substring.length)
        elements.push(React.createElement(MessageFragment, { key: "end" }, substring));
    return React.createElement(React.Fragment, null, elements);
};
//# sourceMappingURL=render.js.map